import React from "react";
import { Icon, Tag } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  height: 30px;

  .ant-tag {
    color: white;
    border-radius: 15px 0px 0px 15px;
    text-transform: uppercase;
    font-weight: bold;
    padding-block: 5px;
    font-size: medium;
    margin: 0 !important;
  }
  .ant-tag span {
    margin-inline: 10px;
    font-size: small;
    vertical-align: top;
  }
  .info {
    color: #747c84;
    border-radius: 0px 15px 15px 0px;
    border-left: 0;
    text-transform: none;
    padding-right: 14px;
    padding-block: 3px;
  }
  .info span {
    font-size: x-small;
    font-weight: 500;
    margin: 0;
    line-height: 1.2;
  }
  .good {
    background-color: #7dcb13;
  }
  .bad {
    background-color: #ff3544;
  }
`;

export function EquifaxTag({ proceed }) {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Tag className={proceed ? "good" : "bad"}>
        <Icon type={`${proceed ? "check" : "close"}-circle`} />
        <span>
          {t(
            `opportunity:process.candidateDetails.equifaxInfo.${
              proceed ? "proceed" : "rejected"
            }`
          )}
        </span>
      </Tag>
      <Tag className="info">
        <span>
          <div>Validado por</div>
          <div>EQUIFAX</div>
        </span>
      </Tag>
    </Wrapper>
  );
}
